import { render, staticRenderFns } from "./ContractFiles.vue?vue&type=template&id=0fb32fe4&"
import script from "./ContractFiles.vue?vue&type=script&lang=js&"
export * from "./ContractFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports